<template>
  <section class="boss-skill-sheet">
    <table class="unstriped boss-table">
      <thead>
        <tr>
          <th
            class="boss-table-head"
            colspan="3"
          >
            職務経歴書
          </th>
        </tr>
      </thead>
      <tbody>
        <template v-for="careerResume in member.careerResumes">
          <tr :key="'tr1-'+careerResume.id">
            <td
              class="boss-table-data-head"
              rowspan="4"
              data-test="resume-from-to"
            >
              {{ careerResume | careerResumeFromToFilter }}
            </td>
            <td
              class="boss-table-data"
              colspan="2"
              data-test="resume-name"
            >
              {{ careerResume | careerResumeNameFilter }}
            </td>
          </tr>
          <tr :key="'tr2-'+careerResume.id">
            <td class="boss-table-data pega-resume-history-sub-title">
              事業内容
            </td>
            <td
              class="boss-table-data pega-pre-wrap"
              data-test="resume-description-1"
              v-text="$options.filters.parseBlankForDefaultValue(careerResume.descriptionTxt1)"
            />
          </tr>
          <tr :key="'tr3-'+careerResume.id">
            <td class="boss-table-data pega-resume-history-sub-title">
              仕事内容
            </td>
            <td
              class="boss-table-data pega-pre-wrap"
              data-test="resume-description-2"
              v-text="$options.filters.parseBlankForDefaultValue(careerResume.descriptionTxt2)"
            />
          </tr>
          <tr :key="'tr4-'+careerResume.id">
            <td class="boss-table-data pega-resume-history-sub-title">
              成果・経験
            </td>
            <td
              class="boss-table-data pega-pre-wrap"
              data-test="resume-description-3"
              v-text="$options.filters.parseBlankForDefaultValue(careerResume.descriptionTxt3)"
            />
          </tr>
        </template>
      </tbody>
    </table>
    <table class="unstriped boss-table">
      <tr>
        <td class="boss-table-data-head">
          最終学歴
        </td>
        <td
          class="boss-table-data pega-pre-wrap"
          colspan="2"
          data-test="graduated-school"
          v-text="$options.filters.graduatedSchoolFilter(member)"
        />
      </tr>
      <tr>
        <td class="boss-table-data-head">
          学歴補足事項
        </td>
        <td
          class="boss-table-data"
          colspan="2"
          data-test="educational-background-note"
        >
          {{ member | defaultLabelFilter('educationalBackgroundNote') | parseBlankForDefaultValue() }}
        </td>
      </tr>
      <tr>
        <td class="boss-table-data-head">
          経験職種
        </td>
        <td
          class="boss-table-data"
          colspan="2"
          data-test="experienced-occupations"
        >
          {{ member | experiencedOccupationsFilter }}
        </td>
      </tr>
      <tr>
        <td class="boss-table-data-head">
          経験業種
        </td>
        <td
          class="boss-table-data"
          colspan="2"
          data-test="experienced-businesses"
        >
          {{ member | defaultLabelFilter('experiencedBusinesses') | parseBlankForDefaultValue() }}
        </td>
      </tr>
      <tr>
        <td class="boss-table-data-head">
          資格
        </td>
        <td
          class="boss-table-data"
          colspan="2"
          data-test="license"
        >
          {{ member | licenseFilter }}
        </td>
      </tr>
      <tr>
        <td class="boss-table-data-head">
          スキル
        </td>
        <td
          class="boss-table-data"
          colspan="2"
          data-test="skill"
        >
          {{ skillExperiencesText | parseBlankForDefaultValue() }}
        </td>
      </tr>
      <tr>
        <td class="boss-table-data-head">
          語学
        </td>
        <td
          class="boss-table-data"
          colspan="2"
          data-test="english"
        >
          {{ member | languageFilter }}
        </td>
      </tr>
      <tr>
        <td
          class="boss-table-data-head"
          rowspan="4"
        >
          希望条件
        </td>
        <td class="boss-table-data pega-resume-sub-title">
          希望勤務地
        </td>
        <td
          class="boss-table-data"
          data-test="desired-work-prefectures"
        >
          {{ member | prefecturesFilter | parseBlankForDefaultValue() }}
        </td>
      </tr>
      <tr>
        <td class="boss-table-data pega-resume-sub-title">
          希望職種
        </td>
        <td
          class="boss-table-data"
          data-test="desired-occupations"
        >
          {{ member | defaultLabelFilter('desiredOccupations') | parseBlankForDefaultValue() }}
        </td>
      </tr>
      <tr>
        <td class="boss-table-data pega-resume-sub-title">
          希望業種
        </td>
        <td
          class="boss-table-data"
          data-test="desired-businesses"
        >
          {{ member | defaultLabelFilter('desiredBusinesses') | parseBlankForDefaultValue() }}
        </td>
      </tr>
      <tr>
        <td class="boss-table-data pega-resume-sub-title">
          希望雇用形態
        </td>
        <td
          class="boss-table-data"
          data-test="desired-employs"
        >
          {{ member | defaultLabelFilter('desiredEmploy') | parseBlankForDefaultValue() }}
        </td>
      </tr>
      <tr>
        <td
          class="boss-table-data-head"
          rowspan="4"
        >
          その他
        </td>
        <td class="boss-table-data pega-resume-sub-title">
          未既婚
        </td>
        <td
          class="boss-table-data"
          data-test="marriage"
        >
          {{ member.marriage | parseBlankForDefaultValue() }}
        </td>
      </tr>
      <tr>
        <td class="boss-table-data pega-resume-sub-title">
          子供有無
        </td>
        <td
          class="boss-table-data"
          data-test="child-status"
        >
          {{ member.childStatus | parseBlankForDefaultValue() }}
        </td>
      </tr>
      <tr>
        <td class="boss-table-data pega-resume-sub-title">
          転居を伴う転職可否
        </td>
        <td
          class="boss-table-data"
          data-test="home-moving"
        >
          {{ member.homeMoving | parseBlankForDefaultValue() }}
        </td>
      </tr>
      <tr>
        <td class="boss-table-data pega-resume-sub-title">
          その他の補足事項
        </td>
        <td
          class="boss-table-data"
          data-test="other-supplement"
        >
          {{ member.otherSupplement | parseBlankForDefaultValue() }}
        </td>
      </tr>      <tr>
        <td class="boss-table-data-head">
          自己PR
        </td>
        <td
          class="boss-table-data pega-pre-wrap"
          data-test="self-pr"
          colspan="2"
          v-text="$options.filters.parseBlankForDefaultValue($options.filters.defaultLabelFilter(member, 'publicRelations'))"
        />
      </tr>
    </table>
  </section>
</template>

<script>

import * as definition from '@/lib/labelValueMappings'
import _ from 'lodash'
import { parseHierarchicalObjects } from '@/lib/parse'
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
export default {
  filters: {
    // 第1引数（label）が真偽判定で偽となる値（nullとか''とか0とかfalseとか...）の場合は'未登録' を返却する
    // それ以外の場合は第1引数（label）+ 第3引数（suffix）を返却する
    parseBlankForDefaultValue (label, suffix = '') {
      return label ? label + suffix : '未登録'
    },
    experiencedOccupationsFilter (member) {
      return [_.get(member, 'presentOccupation'), ..._.get(member, 'experiencedOccupations', [])]
        .filter(x => x && x.name)
        .map(x => x.name)
        .join('、') || '未登録'
    },
    careerResumeNameFilter (careerResume) {
      const companyName = _.get(careerResume, 'companyName')
      const publicationCompanyName = _.get(careerResume, 'publicationCompanyName')
      const employeesNumber = _.get(careerResume, 'employeesNumber')
      const employmentPatternName = _.get(careerResume, 'employmentPattern.name')
      const annualSalary = _.get(careerResume, 'annualSalary')
      return `${publicationCompanyName ? companyName || '社名未登録' : '社名非公開'}（${employeesNumber ? `従業員数${employeesNumber}名` : '従業員数未登録'}）　${employmentPatternName || '雇用形態未登録'}　${annualSalary ? `年収${annualSalary}万円` : '年収未登録'}`
    },
    careerResumeFromToFilter (careerResume) {
      const firstYearMonthArray = (_.get(careerResume, 'firstYearMonth') || '').split('-')
      const lastYearMonthArray = (_.get(careerResume, 'lastYearMonth') || '').split('-')
      // 入社年月および退社年月が未設定＝直近の勤務期間未登録と判断する。
      if (firstYearMonthArray.length !== 2 && lastYearMonthArray.length !== 2) {
        return '勤務期間未登録'
      }
      return `${firstYearMonthArray.length === 2 ? `${firstYearMonthArray[0]}年${firstYearMonthArray[1]}月〜` : ''}${lastYearMonthArray.length === 2 ? `${lastYearMonthArray[0]}年${lastYearMonthArray[1]}月` : '現在就業中'}`
    },
    graduatedSchoolFilter (member) {
      const name = _.get(member, 'graduatedSchool.name')
      const department = _.get(member, 'graduatedSchool.department')
      const yearMonth = _.get(member, 'graduatedSchool.yearMonth', '')
      const educationDepartmentName = _.get(member, 'graduatedEducationDepartment.name')
      if (!name && !department && !yearMonth) return '未登録'
      return `${name || '学校名未登録'}　${department || '学部学科未登録'}（${yearMonth ? dayjs(yearMonth).format('YYYY年MM月卒業') : '卒業年月未登録'}）\n学部学科コード：　${educationDepartmentName || '未登録'}`
    },
    languageFilter (member) {
      const toeicScore = _.get(member, 'toeicScore')
      const toeflScore = _.get(member, 'toeflScore')
      const englishSkillName = _.get(member, 'englishSkill.name')
      const languagesOtherThanEnglish = _.get(member, 'languagesOtherThanEnglish', []).map(otherLangugage => {
        return `${otherLangugage.name.name}(${otherLangugage.level.name})`
      }).join('、')
      return `TOEIC：　${toeicScore ? `${toeicScore}点` : '未登録'}　／　TOEFL：　${toeflScore ? `${toeflScore}点` : '未登録'}　／　英語スキル：　${englishSkillName || '未登録'}　／　英語以外の語学スキル：　${languagesOtherThanEnglish || '未登録'}`
    },
    licenseFilter (member) {
      const licenseNames = (_.get(member, 'licenses') || []).map(license => license.name)
      const otherLicense = _.get(member, 'otherLicense') || ''
      return _.compact([...licenseNames, otherLicense]).join('、') || '保有資格なし'
    },
    prefecturesFilter (member) {
      const value = _.get(member, 'desiredWorkPrefectures')
      if (!value || !value.length) return ''
      return value.map(v => {
        const prefecture = _.get(v, 'name', '')
        const cityLabel = v.cities.map(city => city.name).join('、')
        return cityLabel.length ? `${prefecture}(${cityLabel})` : prefecture
      }).join('、')
    },
    defaultLabelFilter (member, path) {
      const obj = _.get(member, path)
      if (Array.isArray(obj)) {
        return obj.map(x => x.name).join('、')
      } else {
        return obj
      }
    }
  },
  props: {
    member: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      skillsMaster: 'skillsMaster'
    }),
    skillExperiencesText () {
      if (!this.member.skills) return ''
      const experiences = _.filter(parseHierarchicalObjects(this.skillsMaster), master => {
        return this.member.skills.some(skill => skill.id === master.id)
      })

      if (experiences.length === 0) return ''

      // スキルレベル注入
      experiences.map(experience => {
        const experienceSkill = this.member.skills.find(skill => skill.id === experience.id)
        experience.level = experienceSkill.level
      })

      const categories = _.groupBy(experiences, experience => {
        return experience.path[2].name // 中分類
      })

      return Object.keys(categories).map(key => {
        return `[${key}]${categories[key].map(i => {
          return `${i.name}（${definition.registeredExperienceRange.find(item => item.level === i.level).name}）`
        }).join('、')}`
      }).join(' / ')
    }
  }
}
</script>
